import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { AssetCatalogActionPage } from "@/modules/asset_catalog/ActionPage";
import { AssetCatalogVisibilityPage } from "@/modules/asset_catalog/VisibilityPage";
import { AssetCatalogOverviewPage } from "@/modules/asset_catalog/OverviewPage";

/** Asset Catalog (ASSET_CATALOG.md): Overview (all versions, filters, read
 *  drawer) · Product Models (add / edit, any kind).
 *
 *  MANUFACTURERS IS GONE FROM HERE (D-93) — it lives on the organisation,
 *  because a manufacturer IS a party (D-80) and one organisation editable in
 *  two places is how CMP-001 ended up with two names (§9k).
 *
 *  THREE TABS BECAME ONE. Dattatray: *"we dont need 3 subpages under Asset
 *  Catalog ... We can have Batteries, Vehicle and Subcomponents in single
 *  tab: Name of that be Product Models ... Its easier for usability
 *  standpoint!"*
 *
 *  They were always ONE page. Batteries, Vehicles and Subcomponents rendered
 *  the same `AssetCatalogActionPage` with a narrower `kinds` prop — three
 *  routes for one component, differing only in which kinds the picker
 *  offered. A person had to know which tab a BMS lived under before they
 *  could add one, which is backwards: the form asks for the kind anyway.
 *
 *  IT ALSO REMOVES A BUG RATHER THAN ITS SYMPTOM. Sibling routes rendering
 *  one component type at one tree position reconcile instead of remounting,
 *  so switching tabs kept the previous tab's `pickKind` and `mode` — the
 *  D-84 defect, which distinct `key`s papered over. With one tab there are
 *  no siblings to confuse.
 *
 *  THE OLD PATHS REDIRECT rather than 404. They are in bookmarks and in the
 *  Overview drawer's deep links (`?id=`), and the SPA catch-all answers an
 *  unknown path with `index.html` — so a broken link would render a blank
 *  module instead of an error, which is the failure `tests/ui` exists for.
 */
export function AssetCatalogModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav base="/asset-catalog" tabs={[
          { path: "overview", label: "Overview" },
          { path: "models", label: "Product Models" },
          { path: "visibility", label: "Model Visibility" },
        ]} />
      </div>
      <Routes>
        <Route path="overview" element={<AssetCatalogOverviewPage />} />
        {/* `kinds={[]}` = every kind, resolved from the templates the server
            sends. Not a hardcoded list here, so a product added in Products
            appears without this file knowing about it. */}
        <Route path="models" element={
          <AssetCatalogActionPage key="models" eyebrow="Asset Catalog"
            title="Product models" kinds={[]}
            desc="Add a model of any product, or edit one that exists. Choosing the product loads its own spec fields; lists and filters are on Overview." />} />
        {/* MANUFACTURERS MOVED TO ORGANISATIONS (D-93). A manufacturer is a
            FACET of a party (D-80), so editing it here meant one organisation
            editable in two places - and the live data shows what that costs:
            `manufacturers` says "Aphelion Energy Pvt Ltd" while `tenants` says
            "Aphelion Energy", for CMP-001 (§9k).

            Retired only NOW, and the order was part of the decision: this
            page was the only working way to create a maker, so the facet had
            to exist, carry abbr/supplies/country AND logo AND archive, and
            pass its tests first. Retiring it earlier would have left nobody
            able to add one. */}
        {/* VISIBILITY IS NOT PART OF A MODEL'S SPECIFICATION, so it is not a
            section of the model form (Dattatray, 2026-09-28). The form says
            what the thing IS; this says who may USE it, which changes on a
            commercial decision long after the design is frozen. */}
        <Route path="visibility" element={<AssetCatalogVisibilityPage />} />
        <Route path="manufacturers"
          element={<Navigate to="/organisations/organisations" replace />} />

        {/* Retired tabs. Bookmarks and the Overview drawer's deep links still
            point at them, and an unknown path renders a blank module rather
            than erroring, so these redirect and keep the query string. */}
        <Route path="batteries" element={<Navigate to="../models" replace />} />
        <Route path="vehicles" element={<Navigate to="../models" replace />} />
        <Route path="subcomponents" element={<Navigate to="../models" replace />} />

        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  );
}
